import { put, takeEvery } from "redux-saga/effects";

import { loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { UPLOAD_ICON, UploadIconAction, uploadIconFailure, uploadIconSuccess } from "../actions";

export function* uploadIcon(action: UploadIconAction) {
    const { payload } = action;
    const { appId, blob, contentType } = payload;
    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.uploadIcon(appId, blob, contentType);
        yield put(uploadIconSuccess(result.app));
    } catch (e) {
        yield put(uploadIconFailure(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUploadIcon() {
    yield takeEvery(UPLOAD_ICON, uploadIcon);
}
